// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"fe20cea4","63":"0c408fcc","133":"0512e027","301":"5e882ddc","418":"8f029833","444":"cd9deaf2","453":"340ff90f","682":"c609565d","695":"7fb37a42","735":"35b142c7"}[chunkId] + ".chunk.js";
};